import React from 'react';
import { Text, makeStyles } from '@fluentui/react-components';
import ReactMarkdown from 'react-markdown';

interface SegmentProps {
    segmentText: string;
}

const useStyles = makeStyles({
    mainContainer: {
        width: '100%',
        position: 'relative',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#3A3E45',
        borderRadius: '8px',
        padding: '1em',
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #6B7584',
        paddingBottom: '12px',
    },
    segmentTitle: {
        fontFamily: 'Segoe UI',
        fontWeight: 'bold',
        fontSize: '1rem',
    },
    segmentTextContainer: {
        width: '100%',
        backgroundColor: 'transparent',
        paddingTop: '16px',
    },
    segmentText: {
        //display: 'flex',
        width: '100%',
        //justifyContent: 'flex-start',
        //alignItems: 'center',
        fontFamily: 'Segoe UI',
        fontSize: '16px',
        fontWeight: '400',
        lineHeight: '24px',
        color: '#eeeeee',
        '& h1': {
            fontSize: '23px',
            fontWeight: '600',
            lineHeight: '28px',
            margin: '8px 0',
        },
        '& h2': {
            fontSize: '21px',
            fontWeight: '600',
            lineHeight: '26px',
            margin: '6px 0',
        },
    },
    editButton: {
        backgroundColor: '#007738',
        border: '1px solid #008746',
        borderRadius: '4px',
        padding: '1px 8px',
        fontSize: '.7rem',
        color: '#fff',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '4px',
        '&:hover': {
            backgroundColor: '#008746',
            border: '1px solid #008746',
        },
    },
});

const Segment: React.FC<SegmentProps> = ({ segmentText }) => {
    const classes = useStyles();

    return (
        <div className={classes.mainContainer}>
            <div className={classes.header}>
                <Text className={classes.segmentTitle}>Logic Used</Text>
            </div>
            <div className={classes.segmentTextContainer}>
                <ReactMarkdown className={classes.segmentText}>
                    {segmentText}
                </ReactMarkdown>
            </div>
        </div>
    );
};

export default Segment;
